import httpRequest from '../request/indexBase'
import { local } from '@/utils/storage'
import { fetchEventSource } from '@microsoft/fetch-event-source'
import permissionHeader from '@/utils/permissionHeader'

// 查询文本会话聊天列表--图片
export function chatTitleListImage(data) {
  return httpRequest.get({
    url: `/chat/chat-image-title/chatImageTitleList?type=${data.type}&title=${data.title}`
  })
}
// 查询文本会话聊天列表--图片--分镜脚本
export function chatTitleListImageScript(data) {
  return httpRequest.get({
    url: `/chat/chat-image-title/chatImageTitleList?type=${data.type}&title=${data.title}&workflowInfoId=${data.workflowInfoId}`
  })
}
// 查询文本会话聊天列表
export function chatTitleList(data) {
  return httpRequest.get({
    url: `/workflow/chat-title/chatTitleList?type=${data.type}&title=${data.title}`
  })
}
// 创建会话对象--图片
export function saveChatTitleImage(data) {
  return httpRequest.post({
    url: '/chat/chat-image-title/saveChatImageTitle',
    data
  })
}
// 创建会话对象
export function saveChatTitle(data) {
  return httpRequest.post({
    url: '/workflow/chat-title/saveChatTitle',
    data
  })
}
// 批量修改图片生成表实体
export function updateChatImageTitleBatch(data) {
  return httpRequest.put({
    url: '/chat/chat-image-title/updateChatImageTitleBatch',
    data
  })
}
// 批量修改图片生成表实体
export function updateChatVideoTitleBatch(data) {
  return httpRequest.put({
    url: '/workflow/chat-title/updateChatVideoTitleBatch',
    data
  })
}
// 查询会话对象
export function queryUserToContinue(params) {
  return httpRequest.get({
    url: '/chat/queryUserToContinue',
    params
  })
}
// 删除对话 对象--图片生成
export function deleteRecordIdsImage(data) {
  return httpRequest.put({
    url: '/chat/chat-image-title/deleteChatImageTitleSelectType',
    data
  })
}
// 删除对话 对象
export function deleteRecordIds(data) {
  return httpRequest.put({
    url: '/workflow/chat-title/deleteChatTitleSelectType',
    data
  })
}
// 修改会话标题--tupian
export function updateTitleImage(data) {
  return httpRequest.put({
    url: '/chat/chat-image-title/updateChatImageTitle',
    data
  })
}
// 修改会话标题
export function updateTitle(data) {
  return httpRequest.put({
    url: '/workflow/chat-title/updateTitle',
    data
  })
}
// 根据会话id查询聊天记录--tupian
export function queryChatRecordImage(data) {
  return httpRequest.get({
    url: `/chat/chat-image-record/queryChatImageRecord?id=${data.id}&prompt=${data.prompt}`
  })
}
// 根据会话id查询聊天记录
export function queryChatRecord(data) {
  return httpRequest.get({
    url: `/workflow/queryChatRecord?id=${data.id}&prompt=${data.prompt}`
  })
}

// 根据id查询AI会话模型
export function chatTitle(id) {
  return httpRequest.get({
    url: `/workflow/chat-title/${id}`
  })
}

// 批量保存聊天记录
export function saveRecordToWord(data) {
  return httpRequest.post({
    url: '/workflow/saveRecordToWord',
    data
  })
}

// 发送信息 有两个模型不同方法  1chat   deep-seek
export function chatDeepseek(data) {
  return httpRequest.post({
    // url: `/chat/chatMemoryOpenAi`,
    url: `/chat/chatMemoryOpenAiJson`,
    data
  })
}

// 2豆包模型
export function chatLocal(data) {
  return httpRequest.post({
    url: `/chat/chatMemoryLocal`,
    data
  })
}

// 提示词优化
export function tipWord(data) {
  return httpRequest.post({
    url: `/chat/tipWordOptimizationNoStream`,
    data
  })
}

// 获取知识库列表
export function personalDataList() {
  return httpRequest.get({
    url: `/weaviate/personalDataLibrary/personalDataList`
  })
}

// 图片生成--------------
export function imageGenerate(data) {
  return httpRequest.post({
    url: '/chat/imageGenerateZH',
    data
  })
}

// 根据生成id 查询生成结果
export function imageObtain(id) {
  return httpRequest.get({
    url: `/chat/imageObtainZH?id=${id}`
  })
}
// 根据生成id 查询生成结果---分镜脚本  todo
export function imageObtainZHWorkflow(id) {
  return httpRequest.get({
    url: `/chat/imageObtainZHWorkflow?id=${id}`
  })
}

// 图片操作按钮
export function imageDetailGenerate(data) {
  return httpRequest.post({
    url: `/chat/imageDetailGenerateZH`,
    data
  })
}
// 图片生成翻译提示词/ai-backend/chat/chat-image-record/getImagePromptTranslation
export function getImagePromptTranslation(params) {
  return httpRequest.get({
    url: `/chat/chat-image-record/getImagePromptTranslation`,
    params
  })
}
// 删除图片生成结果---图片生产
export function deleteImageResult(data) {
  return httpRequest.put({
    url: '/chat/chat-image-record/deleteImageRecordIds',
    data
  })
}
// 删除图片生成结果
export function deleteImage(data) {
  return httpRequest.put({
    url: '/workflow/deleteRecordIds',
    data
  })
}

// 视频生成---------
export function videoGenerate(data) {
  return httpRequest.post({
    url: '/chat/videoGenerate2Redis',
    data
  })
}

// 根据messageID 查询结果
export function videoObtain(id) {
  return httpRequest.get({
    url: `/chat/videoObtainRedis?id=${id}`
  })
}

// 查询文件夹列表
export function chatDirectoryList() {
  return httpRequest.get({
    url: '/workflow/chat-directory/chatDirectoryList'
  })
}

// 讲会话移动至文件夹
export function mvChatTitleSelectType(data) {
  return httpRequest.put({
    url: '/workflow/chat-title/mvChatTitleSelectType',
    data
  })
}

// 历史会话删除
export function deleteChatTitleSelectType(data) {
  return httpRequest.put({
    url: '/workflow/chat-title/deleteChatTitleSelectType',
    data
  })
}

// 文件夹删除、
export function deleteChatDirectory(data) {
  return httpRequest.put({
    url: '/workflow/chat-directory/deleteChatDirectory',
    data
  })
}

// 修改文件夹名称
export function updateDir(data) {
  return httpRequest.put({
    url: '/workflow/chat-directory/updateDir',
    data
  })
}

// 文件夹id
export function chatDirTitleList(id) {
  return httpRequest.get({
    url: `/workflow/chat-title/chatDirTitleList?dirId=${id}`
  })
}

// 创建文件夹
export function saveChatDir(data) {
  return httpRequest.post({
    url: '/workflow/chat-directory/saveChatDir',
    data
  })
}

// 添加到会话
export function saveAppConversation(params) {
  return httpRequest.get({
    url: '/workflow/saveAppConversation',
    params
  })
}

// 添加到收藏
export function addFavoriteApp(data) {
  return httpRequest.post({
    url: '/workflow/my-application/addFavoriteApp',
    data: data
  })
}

// 取消收藏
export function deleteBookmark(data) {
  return httpRequest.post({
    url: `/workflow/my-application/deleteBookmark`,
    data
  })
}

// 文件上传
export function imageUpload(data) {
  return httpRequest.post({
    url: '/repository/files-record/upload',
    data
  })
}
// 区域重绘
export function imageRegionVary(data) {
  return httpRequest.post({
    url: '/chat/imageRegionVary',
    data
  })
}
// 视频生成 超清智能按钮
export function videoGenerateByCreationId(Id) {
  return httpRequest.get({
    url: `/chat/videoGenCutByCreationId?creationId=${Id}`
  })
}
// 混图生成接口
export function imagesBlend(data) {
  return httpRequest.post({
    url: '/chat/imagesBlend',
    data
  })
}
// 咒语解析生成接口 根据图片生成描述内容
export function imagesDescription(data) {
  return httpRequest.post({
    url: '/chat/imagesDescription',
    data
  })
}
// 查询图片积分消耗
export function getPointsConfigImageList() {
  return httpRequest.get({
    url: '/getPointsConfigImageList'
  })
}
// 查询视频积分消耗
export function getPointsConfigVideoList(data) {
  return httpRequest.post({
    url: '/getPointsConfigVideoList',
    data
  })
}
// 替换图片
export function updateStoryboardImage(data) {
  return httpRequest.post({
    url: '/workflow/workflow-execute-record/updateStoryboardImage',
    data
  })
}

// 脚本运行下载
export function exportActionResult(params) {
  return httpRequest.get({
    url: `/workflow/result/exportActionResult`,
    params,
    responseType: 'blob'
  })
}

// 会话重连
export function reconnectionChat(runId, onopen, onmessage, onclose, onerror, ctrl) {
  return fetchEventSource(process.env.VUE_APP_API_URL + `/chat/chatCompletionContinue/${runId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      token: local.get('TOKEN'),
      ...permissionHeader()
    },
    signal: ctrl.signal,
    openWhenHidden: true,
    onopen(response) {
      // 开启流
      console.log('onopen')

      onopen && onopen(response)
    },
    onmessage(event) {
      // 监听流
      onmessage && onmessage(event)
    },
    onclose(e) {
      // 关闭流
      onclose && onclose(e)
    },
    onerror: (e) => {
      //返回流报错
      onerror && onerror(e)
      throw e
    }
  })
}

// 可灵图片生成
export function kLingImage(data) {
  return httpRequest.post({
    url: '/chat/kLingImage',
    data
  })
}
// Nano Banana 图片生成
export function nanoBananaImage(data) {
  return httpRequest.post({
    url: '/chat/nanoBananaImage',
    data
  })
}
// seedDreamImage 图片生成
export function seedDreamImage(data) {
  return httpRequest.post({
    url: '/chat/seedDreamImage',
    data
  })
}
// 图片详情 查询
export function imageObtainZH(params) {
  return httpRequest.get({
    url: `/chat/imageObtainZH`,
    params
  })
}
